import { render, staticRenderFns } from "./GuestRelations.vue?vue&type=template&id=7ffcc390&"
import script from "./GuestRelations.vue?vue&type=script&lang=js&"
export * from "./GuestRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports